import * as React from "react";
const SvgFiRrBrainCircuit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-brain-circuit_svg__a)">
      <path
        fill="#062147"
        d="M24 11c0-1.568-.752-3.04-2-3.979V7a4.01 4.01 0 0 0-3.102-3.898A4.01 4.01 0 0 0 15 0a4 4 0 0 0-3 1.357A3.99 3.99 0 0 0 9 0a4.01 4.01 0 0 0-3.898 3.102A4.01 4.01 0 0 0 2 7v.021A4.99 4.99 0 0 0 0 11c0 .886.235 1.737.686 2.5A4.9 4.9 0 0 0 0 16c0 1.686.858 3.244 2.267 4.166A5.47 5.47 0 0 0 7.5 24a5.5 5.5 0 0 0 4.5-2.342A5.5 5.5 0 0 0 16.5 24a5.465 5.465 0 0 0 5.233-3.834A4.98 4.98 0 0 0 24 16a4.9 4.9 0 0 0-.686-2.5A4.9 4.9 0 0 0 24 11M7.5 22a3.48 3.48 0 0 1-3.401-2.712 1 1 0 0 0-.502-.656A2.99 2.99 0 0 1 2 16.001c0-.675.234-1.322.679-1.872a1 1 0 0 0 0-1.257A2.96 2.96 0 0 1 2 11c0-1.07.591-2.067 1.543-2.603a1 1 0 0 0 .494-1.045A2 2 0 0 1 4 7c0-1.103.897-2 2-2a1 1 0 0 0 1-1c0-1.103.897-2 2-2s2 .897 2 2v4H8.732A1.999 1.999 0 0 0 5 9a2 2 0 0 0 3.732 1H11v5H8.732A1.999 1.999 0 0 0 5 16a2 2 0 0 0 3.732 1H11v1.5c0 1.93-1.57 3.5-3.5 3.5m13.821-7.872c.444.549.679 1.196.679 1.872a2.99 2.99 0 0 1-1.597 2.631 1 1 0 0 0-.502.656 3.48 3.48 0 0 1-3.401 2.712c-1.93 0-3.5-1.57-3.5-3.5v-4.5h2c1.654 0 3-1.346 3-3v-.268a1.999 1.999 0 0 0-1-3.732 2 2 0 0 0-1 3.732v.268c0 .551-.448 1-1 1h-2V4c0-1.103.897-2 2-2s2 .897 2 2a1 1 0 0 0 1 1c1.103 0 2 .897 2 2 0 .121-.018.237-.037.352a1 1 0 0 0 .494 1.045A3 3 0 0 1 22 11c0 .675-.234 1.322-.679 1.872a1 1 0 0 0 0 1.256"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-brain-circuit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBrainCircuit;
